import RouteTemplate from 'ember-route-template'
import { ContactUs } from 'teacher-ui-client/components/page/contact-us'

export default RouteTemplate(ContactUs)
